import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * ============================================================
 * ROUTE GUARD - login aur role check
 * ============================================================
 *
 * ⚠️ YE KYUN CHAHIYE:
 *
 * Pehle koi bhi URL type karke koi bhi page khol sakta tha:
 *   /my-bookings       <- bina login
 *   /poojari-dashboard <- user bhi khol leta
 *   /admin-dashboard   <- koi bhi khol leta
 *
 * Data leak nahi hota tha (backend ke ownership guards use rok
 * dete hain), par page khul jaata tha - khaali, toota hua, ya
 * error toast ke saath. Dekhne mein lagta ki admin panel tak
 * pahunch gaye.
 *
 * ⚠️ YE SURAKSHA NAHI HAI - SIRF UX HAI:
 *
 * Frontend ka koi bhi check browser mein badla ja sakta hai.
 * Asli suraksha BACKEND ke guards hain (AuthGuard.assertSelf,
 * assertAdmin). Ye component sirf ye karta hai ki galat banda
 * galat page pe pahunch ke confuse na ho.
 *
 * Isliye yahan koi API call nahi, koi bharosa nahi - bas
 * localStorage dekh ke sahi jagah bhej dete hain.
 *
 * ⚠️ localStorage seedha kyun, useAuth() se kyun nahi:
 * AuthContext bhi apni value localStorage se hi uthata hai, par
 * wo state pehle render ke baad settle hoti hai. Yahan faisla
 * render se PEHLE chahiye, warna protected page ek jhalak ke
 * liye dikh jaayega phir gayab hoga.
 *
 * ISTEMAAL:
 *   <Route path="/my-bookings" element={
 *       <ProtectedRoute allow="USER"><MyBookings /></ProtectedRoute>
 *   } />
 */
const ProtectedRoute = ({ children, allow }) => {
	const location = useLocation();

	const token = localStorage.getItem('token');
	const role = localStorage.getItem('role');

	// Login hi nahi hai - role ke hisaab se sahi login page pe bhejo
	if (!token) {
		// ⚠️ replace: true - taaki back button dabane pe wapas is
		// page pe na aa jaaye aur loop na bane
		const loginPath = allow === 'POOJARI' ? '/poojari-login'
			: allow === 'ADMIN' ? '/admin-login'
				: '/login';
		return <Navigate to={loginPath} replace state={{ from: location.pathname }} />;
	}

	// Login to hai, par galat role - apne dashboard pe wapas bhejo
	if (allow && !isAllowed(role, allow)) {
		return <Navigate to={homeFor(role)} replace />;
	}

	return children;
};

/**
 * Role match karta hai?
 *
 * ⚠️ ADMIN wale page SUPER_ADMIN ko bhi khulne chahiye -
 * SUPER_ADMIN wahi admin hai jo doosre admins ko approve karta
 * hai, uske paas normal admin ka saara access bhi hai. Backend
 * ka AuthGuard.isAdmin() bhi dono maanta hai.
 */
const isAllowed = (role, allow) => {
	if (allow === 'ADMIN') {
		return role === 'ADMIN' || role === 'SUPER_ADMIN';
	}
	return role === allow;
};

/** Is role ka apna home page kaunsa hai */
const homeFor = (role) => {
	if (role === 'POOJARI') return '/poojari-dashboard';
	if (role === 'ADMIN' || role === 'SUPER_ADMIN') return '/admin-dashboard';
	return '/home';
};

export default ProtectedRoute;